<template>
  <div class="auth">
    <van-loading color="#1989fa" size="50px" vertical>登录中...</van-loading>
  </div>
</template>

<script>
import { Loading, Dialog } from 'vant';
import dayjs from 'dayjs';

export default {
  components: {
    [Loading.name]: Loading
  },

  data() {
    return {
      url: ''
    };
  },

  methods: {
    getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
  },

  created() {
    const code = this.getQueryString('code');
    if (code) {
      // alert('用户有code，接下来调用user/code的函数')
      // 未登录拦截跳转逻辑 在 router.js
      this.$axios.get('user/code?code=' + code).then(res => {
        // alert('我是函数返回的结果')
        localStorage.setItem('user_id', res);
        localStorage.setItem('auth_date', dayjs(new Date()).format('YYYY-MM-DD'));
        // alert('跳转路径'+localStorage.getItem('now_url') )
        
        // this.$router.push(localStorage.getItem('now_url').split('#')[1])
        location.href = localStorage.getItem('now_url')
      }).catch(res => {
        Dialog.alert({
          title: '登录失败',
          message: res
        })
      })
    } else {
      // location.href
      // alert('调用auth/url' +encodeURIComponent(localStorage.getItem('now_url')))
      const hostUrl = localStorage.getItem('now_url') || location.href
      this.$axios.get('wx/auth/url?host=' + encodeURIComponent(hostUrl)).then(res => {
        // alert('res返回'+res)
        location.href = res
      }).catch(res => {
        Dialog.alert({
          title: '获取登录链接失败',
          message: res
        })
      })
    }
  }
};
</script>

<style lang="less" scoped>
  .auth {
    margin-top: 50%;
  }
</style>
